<template>
  <div class="mt-2">
    <div class="row g-2" v-if="datas.length > 0">
      <div
        class="col-lg-2 col-md-4 col-sm-4 col-12"
        v-for="(n, i) in datas"
        :key="i"
      >
        <div class="imgs">
          <div @click="setPreview(n)" style="position: relative;">
            <img
              :src="n.imageurl ? n.imageurl : '../../assets/image/noimage.png'"
              alt="Image Preview"
              class="img img-fluid"
              loading="lazy"
            />
            <p class="text-end me-2 mb-2" style="position: absolute; right: 0; bottom: 0; font-size: 15px;">
              <span
                v-if="n.status === '1'"
                class="badge rounded-pill text-bg-warning ps-2 pe-2 pt-1 pb-1"
                >Waiting</span
              >
              <span
                v-if="n.status === '2'"
                class="badge rounded-pill text-bg-success ps-2 pe-2 pt-1 pb-1"
                >Approved</span
              >
              <span
                v-if="n.status === '3'"
                class="badge rounded-pill text-bg-danger ps-2 pe-2 pt-1 pb-1"
                >Rejected</span
              >
            </p>
          </div>
          <div
            style="font-size: 12px; border-top: 1px solid rgba(92, 92, 92, 0.3)"
            class="p-2"
          >
            <p class="overflow-hide">
              Barcode : {{ n.originalname }}
            </p>
            <p class="overflow-hide">
              Internal : {{ n.internal }}
            </p>
            <p class="overflow-hide">Deskripsi : {{ n.descript }}</p>
            <p v-if="n.status === '3'">
              Alasan Reject : {{ n.desc_rejected ? n.desc_rejected : "-" }}
            </p>
          </div>
          <div
            class="delete-img"
            v-if="!statusCheckedImage && n.status === '1'"
          >
            <i
              class="fas fa-times-circle"
              data-bs-toggle="modal"
              data-bs-target="#deleteModal"
              @click="setDeleted(n)"
            ></i>
          </div>
          <div
            class="checked-img"
            v-if="statusCheckedImage && n.status === '1'"
          >
            <input
              style="width: 20px !important; height: 20px !important"
              type="checkbox"
              :value="n"
              v-model="tempImages"
              id="flexCheckDefault"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="text-center p-2"
      v-if="datas.length < 1"
      style="background-color: #f2f2f2"
    >
      <img src="../../assets/image/noimage.png" alt="" height="200" />
    </div>
    <DeleteModalComponent
      :data="data"
      @saveDelete="deleteImage"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteModalComponent from "@/components/DeleteModalComponent.vue";

export default {
  name: "GaleryImageProductComponent",
  data() {
    return {
      data: {},
    };
  },
  components: {
    DeleteModalComponent,
  },
  computed: {
    ...mapState({
      datas: (state) => state.ImageProduct.datas,
      statusCheckedImage: (state) => state.ImageProduct.statusCheckedImage,
    }),
    tempImages: {
      get() {
        return this.$store.state.ImageProduct.tempCheckedImages;
      },
      set(value) {
        this.$store.commit("ImageProduct/SET_TEMP_CHECKED_IMAGE", value);
      },
    },
  },
  methods: {
    ...mapActions({
      deleteImage: "ImageProduct/delete",
    }),
    setDeleted(value) {
      this.data = value;
    },
    setPreview(data) {
      this.$store.commit("ImageProduct/SET_DATA_PREVIEW", data);
      this.$store.commit("ImageProduct/SET_PREVIEW");
    },
  },
};
</script>
<style scoped>
.imgs {
  position: relative;
  object-fit: cover !important;
  position: relative !important;
  border: 1px solid rgba(59, 58, 58, 0.1);
  box-shadow: 4px 4px 16px rgba(92, 92, 92, 0.1);
  border-radius: 5px;
  padding: 5px;
  width: 100%;
  /* height: 400px; */
}

@media (max-width: 576px) {
  .imgs {
    height: 100%;
  }
}

.imgs:hover {
  border: 1px solid rgba(20, 79, 216, 0.3);
  box-shadow: 4px 4px 16px rgba(20, 79, 216, 0.3);
  transition: all 0.3s ease;
}
.imgs .img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  border-radius: 8px;
}
.imgs .overflow-hide {
  margin-bottom: 0 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* Potong teks panjang */
}
.imgs .delete-img {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  margin-top: 2px;
  margin-right: 5px;
  color: rgba(215, 7, 7, 0.6);
}
.imgs .delete-img:hover {
  color: rgb(236, 7, 7);
  cursor: pointer;
  transition: all 0.3s ease;
}
.imgs .checked-img {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  margin-top: 5px;
  margin-right: 5px;
}
</style>
